module.exports = __webpack_public_path__ + "img/station_05.85e7be8e.jpg";